import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const BuddiesRedirect: React.FC = () => <Navigate to="/profile?tab=buddies" replace />;

export const AccountSecurityRedirect: React.FC = () => <Navigate to="/settings" replace />;

export const MfaRedirect: React.FC = () => <Navigate to="/mfa-setup" replace />;

export const LegacyTeeTimesRedirect: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const clubCode = (clubId ?? '').trim();

  return (
    <Navigate to={clubCode ? `/club/${encodeURIComponent(clubCode)}/teetimes` : '/club'} replace />
  );
};
